import React from "react";
import "./Residential.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Louiseimages from "../../Media/Produk/Louise/Louise";
import Ardeaimages from "../../Media/Produk/Ardea/Ardea";
import Heronimages from "../../Media/Produk/Heron/Heron";
import Strozziimages from "../../Media/Produk/Strozzi/Strozzi";
import Leonoraimages from "../../Media/Produk/Leonora/Leonora";
import Carsonimages from "../../Media/Produk/Carson/Carson";
import Mozartimages from "../../Media/Produk/Mozart/Mozart";
import Bellefontimages from "../../Media/Bellefont/Bellefont";

const imageMap = {
  Louiseimages,
  Ardeaimages,
  Heronimages,
  Strozziimages,
  Leonoraimages,
  Bellefontimages,
  Carsonimages,
  Mozartimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
